import { EVENT_NAME } from '../constants/branding'
import './Competitors.css'

const COMPETITORS = [
  'AC Slater',
  'AG',
  'AgentMidnight',
  'Alpha',
  'Arnco EM',
  'Bamatecmo',
  'Barletti',
  'Beef Juice',
  'Big Wiz',
  'bigred17machine',
  'Birdhas',
  'BobbyDigital',
  'Bruddog',
  'Cance',
  'Char Mart',
  'Chesty Puller',
  'DKS',
  'DPS',
  'Disciple',
  'Dukesta',
  'Edboi',
  'Eifer',
  'FanGamesPlayer',
  'FastEd',
  'Fatginger',
  'Fox',
  'fulltimeslacker',
  'kilonine',
  'hankthetank',
  'Jbrooks',
  'JPthebowler',
  'jspy76',
  'kmolnar',
  'Lazlo',
  'Lil Wiz',
  'LudioWon',
  'Mr. Ass',
  'MX',
  'Nellyville',
  'Nelson79',
  'Nos',
  'nostradamus',
  'NotoriousBDN',
  'Protajay',
  'Ptitteri',
  'PunkyQB',
  'RandyWags',
  'regulator',
  'richiesmith',
  'Riddler',
  'Rhythm City RM',
  'Sammiesmith',
  'SimpleSimon',
  'Slig',
  'Spinksmatt',
  'Swamp',
  'Tecmo Ninja',
  'TecmoBo',
  'Toolie',
  'Turd Ferguson',
  'Ultada',
  'Uyio',
  'vgifted1',
  'VikingMoe',
  'Yooper',
  'ZackAttack',
]

export default function Competitors() {
  return (
    <div className="competitors-page">
      <h1>{EVENT_NAME} Competitors</h1>
      <div className="competitors-board">
        <div className="competitors-overlay">
          <div className="competitors-grid">
            {COMPETITORS.map((name) => (
              <div key={name} className="competitor-name">
                {name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
